import NpsWidget from './NpsWidget';
export default NpsWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsWidget/index.js